import { render, staticRenderFns } from "./SerachForm.vue?vue&type=template&id=199b4f5d&scoped=true"
import script from "./SerachForm.vue?vue&type=script&lang=js"
export * from "./SerachForm.vue?vue&type=script&lang=js"
import style0 from "./SerachForm.vue?vue&type=style&index=0&id=199b4f5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b4f5d",
  null
  
)

export default component.exports